import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { IDocViewerConfig } from './doc-viewer.config';

@Component({
  selector: 'doc-viewer',
  templateUrl: './doc-viewer.component.html',
  styleUrls: ['./doc-viewer.component.scss']
})
export class DocViewerComponent implements OnInit, OnChanges {
  
  @Input() module: any;
  @Input() height: string = '80vh';
  @Input() config: IDocViewerConfig;
  @ViewChild('pdfViewer') pdfViewer;
  
  constructor() { }
  
  ngOnChanges(changes: SimpleChanges): void {
   
  }
  
  ngOnInit() {
   
  }
}